import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { I18n, setLocale } from 'react-redux-i18n'
import moment from 'moment'

import {
  Modal,
  Form,
  Input,
  Button,
  Spin,
  Select,
  message,
  Switch,
  Checkbox,
  Typography,
  DatePicker, Badge,
  Divider,
} from 'antd'
import { MinusCircleOutlined, EditOutlined, PlusOutlined, AppstoreAddOutlined } from '@ant-design/icons';

import * as ToolRequest from '../../tools/ToolRequest'
import SpinFull from '../../components/SpinFull'

const formLayout = {
  labelCol: {
    md: { span: 5 },
    sm: { span: 24 },
  },
  wrapperCol: {
    md: { span: 16 },
  },
}

const formTailLayout = {
  wrapperCol: {
    md: { offset: 5, span: 16 },
  },
}

const { TextArea } = Input
const { Option } = Select
const { Text } = Typography

export default function FamilyBatchEditModal(props) {
  const userData = useSelector(state => state.user.value)
  const { familyIds, visible, onOk, onCancel } = props
  const [loaded, setLoaded] = useState(false)
  const [loading, setLoading] = useState(false)
  const [regionOptions, setRegionOptions] = useState([])
  const [serviceOptions, setServiceOptions] = useState(false)
  const [serviceRequired, setServiceRequired] = useState(false)
  const [beginAtRequired, setBeginAtRequired] = useState(false)
  const [form] = Form.useForm();
  const sources = ['AFD-1', 'AFD-2', 'AFD-3', 'Admin', '社署', '自助站', '社區中心', 'Intake長者']

  useEffect(() => {
    (async () => {
      try {
        const [regionRes, serviceRes] = await Promise.all([
          ToolRequest.request('GET', `/region`),
          ToolRequest.request('GET', `/service`)
        ])
        const regionOptions = regionRes.data.map(item => {
          return <Option key={item.id}>{item.name[userData.locale]}</Option>
        })
        setRegionOptions(regionOptions)
        const options = serviceRes.data.map(item => {
          return <Option key={item.id}>{item.name[userData.locale]}</Option>
        })
        setServiceOptions(options)
      } catch (e) {
        message.error(e)
      }
      setLoaded(true)
    })()
  }, [])

  const handleServiceCheckboxChange = (e) => {
    const fields = ['beginAt', 'endAt', 'memberServiceOption']
    let checked = false
    let beginAtChecked = false
    for (const field of fields) {
      const value = form.getFieldValue(field)
      if (value?.checkbox) {
        checked = true
        if (field === 'beginAt') beginAtChecked = true
      }
    }
    setServiceRequired(checked)
    setBeginAtRequired(beginAtChecked)
  };

  const onFinish = async (values) => {
    console.dir(values)
    try {
      let data = {}
      for (let key in values) {
        const value = values[key]
        if (value && value.hasOwnProperty('checkbox') && value.checkbox) {
          data[key] = value.value
        }
      }
      console.dir(data)
      if (Object.keys(data).length <= 0) {
        await Promise.reject(new Error('請至少選擇一個修改項'))
      }
      Modal.confirm({
        title: `已選擇 ${Object.keys(data).length} 個修改項，保存請按確定，返回選擇請按取消`,
        okType: 'danger',
        onOk: () => {
          (async () => {
            try {
              setLoading(true)
              const familySeviceFields = ['beginAt', 'endAt']
              await Promise.all(familyIds.map(familyId => {
                {
                  ToolRequest.request('PUT', `/family/${familyId}`, data)
                  let hasBeginEndAt = false
                  for (const familySeviceField of familySeviceFields) {
                    if (data[familySeviceField]) {
                      hasBeginEndAt = true
                      break
                    }
                  }
                  if (hasBeginEndAt) {
                    ToolRequest.request('GET', `/family-service/v1`, { familyId, serviceId: values.serviceId, sort:'created_at',order:'desc',limit:1}).then((familyServiceRes) => {
                      if (familyServiceRes.data.length) {
                        const familyService = familyServiceRes.data[0]
                        ToolRequest.request('PUT', `/family-service/${familyService.id}`, data)
                      }
                    })
                  }
                  if(data['memberServiceOption'] && data['memberServiceOption'] !== 'keep') {
                    ToolRequest.request('GET', `/member`, { familyId}).then((memberRes) => {
                      const members = memberRes.data
                      const isEnabled = data['memberServiceOption'] === 'true'
                      for (const member of members) {
                        ToolRequest.request('GET', `/member-service`, { memberId: member.id, serviceId: values.serviceId,sort:'created_at',order:'desc',limit:1}).then(memberServiceRes=>{
                          if (memberServiceRes.data.length) {
                            const memberService = memberServiceRes.data[0]
                            ToolRequest.request('PUT', `/member-service/${memberService.id}`, {isEnabled})
                          }
                        })
                      }
                    })
                  }
                }
              }))
              // for (let familyId of familyIds) {
              //   promises.push(ToolRequest.request('PUT', `/family/${familyId}`, data)) 
              //   let hasBeginEndAt = false
              //   for (const familySeviceField of familySeviceFields) {
              //     if (data[familySeviceField]) {
              //       hasBeginEndAt = true
              //       break
              //     }
              //   }
              //   if (hasBeginEndAt) {
              //     const familyServiceRes = await ToolRequest.request('GET', `/family-service/v1`, { familyId, serviceId: data.serviceId, statuses: ['ONGOING', 'WAITING'] })
              //     console.dir(familyServiceRes);
              //     if (familyServiceRes.data.length) {
              //       const familyService = familyServiceRes.data[0]
              //       promises.push(ToolRequest.request('PUT', `/family-service/${familyService.id}`, data)) 
              //     }
              //   }
              //   if(data['memberServiceOption'] && data['memberServiceOption'] !== 'keep') {
              //     const memberRes = await ToolRequest.request('GET', `/member`, { familyId})

              //     promises.push(ToolRequest.request('PUT', `/family-service/${familyService.id}`, data)) 
              //   }
              // }
              message.success(I18n.t('editSuccessMessage'))
              onOk()
              setLoading(false)
            } catch (err) {
              console.dir(err)
              setLoading(false)
              if (err?.response?.data) {
                console.dir(err.response.data)
                switch (err.response.data) {
                  default:
                    return message.error(I18n.t('errorMessageUnknownError'))
                }
              } else {
                if (err && err.message) {
                  message.error(err.message)
                } else {
                  message.error(I18n.t('errorMessageUnknownError'))
                }
              }
            }
          })()
        },
      })
    } catch (err) {
      console.dir(err)
      setLoading(false)
      if (err?.response?.data) {
        switch (err.response.data) {
          default:
            return message.error(I18n.t('errorMessageUnknownError'))
        }
      } else {
        message.error(err && err.message)
      }
    }
  }

  return (
    <Modal
      title={I18n.t('批量編輯家庭')}
      visible={visible}
      onCancel={onCancel}
      width="50%"
      maskClosable={false}
      footer={null}
    >
      {loaded ? (
        <Spin spinning={loading}>
          <Form
            form={form}
            {...formLayout}
            initialValues={
              {
                isEnabled: {
                  value: true
                }
              }
            }
            onFinish={onFinish}
          >
            <Text type="warning">注意：在提交前請務必先在需要修改的選項後面打√</Text>
            <Form.Item label="啟用">
              <Input.Group compact>
                <Form.Item
                  noStyle={false}
                  valuePropName="checked"
                  name={['isEnabled', 'value']}
                >
                  <Switch />
                </Form.Item>
                <Form.Item
                  noStyle={false}
                  valuePropName="checked"
                  name={['isEnabled', 'checkbox']}
                  style={{ marginLeft: "10px" }}
                >
                  <Checkbox>修改此項</Checkbox>
                </Form.Item>
              </Input.Group>
            </Form.Item>

            <Form.Item label="轉介來源">
              <Input.Group compact style={{ width: '100%' }}>
                <Form.Item
                  noStyle={false}
                  name={['source', 'value']}
                >
                  <Select placeholder={I18n.t('轉介來源')}>
                    {sources.map(source => (<Option value={source}>
                      {source}
                    </Option>))}
                  </Select>
                </Form.Item>
                <Form.Item
                  noStyle={false}
                  valuePropName="checked"
                  name={['source', 'checkbox']}
                  style={{ marginLeft: "10px" }}
                >
                  <Checkbox>修改此項</Checkbox>
                </Form.Item>
              </Input.Group>
            </Form.Item>

            <Form.Item label="地區">
              <Input.Group compact>
                <Form.Item
                  noStyle={false}
                  name={['regionId', 'value']}
                >
                  <Select
                    style={{
                      width: '200px',
                    }}
                    showSearch
                    placeholder={I18n.t('選擇地區')}
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {regionOptions}
                  </Select>
                </Form.Item>
                <Form.Item
                  noStyle={false}
                  valuePropName="checked"
                  name={['regionId', 'checkbox']}
                  style={{ marginLeft: "10px" }}
                >
                  <Checkbox>修改此項</Checkbox>
                </Form.Item>
              </Input.Group>
            </Form.Item>

            <Form.Item label="經濟狀況">
              <Input.Group compact>
                <Form.Item
                  style={{
                    width: '200px',
                  }}
                  name={['economicStatus', 'value']}
                >
                  <Select placeholder={I18n.t('經濟狀況')}>
                    <Option value="有收入">
                      {I18n.t('有收入')}
                    </Option>
                    <Option value="領取綜援金">
                      {I18n.t('領取綜援金')}
                    </Option>
                    <Option value="其它">
                      {I18n.t('其它')}
                    </Option>
                  </Select>
                </Form.Item>
                <Form.Item
                  noStyle={false}
                  valuePropName="checked"
                  name={['economicStatus', 'checkbox']}
                  style={{ marginLeft: "10px" }}
                >
                  <Checkbox>修改此項</Checkbox>
                </Form.Item>
              </Input.Group>
            </Form.Item>

            <Form.Item label="短訊發送時間">
              <Input.Group compact>
                <Form.Item
                  name={['smsSentAt', 'value']}
                >
                  <DatePicker
                    showTime
                    placeholder={I18n.t('短訊發送時間')}
                  />
                </Form.Item>
                <Form.Item
                  noStyle={false}
                  valuePropName="checked"
                  name={['smsSentAt', 'checkbox']}
                  style={{ marginLeft: "10px" }}
                >
                  <Checkbox>修改此項</Checkbox>
                </Form.Item>
              </Input.Group>
            </Form.Item>

            <Form.Item label="備註">
              <Input.Group compact>
                <Form.Item
                  name={['remark', 'value']}
                >
                  <TextArea
                    placeholder={I18n.t('備註')}
                  />
                </Form.Item>
                <Form.Item
                  noStyle={false}
                  valuePropName="checked"
                  name={['remark', 'checkbox']}
                  style={{ marginLeft: "10px" }}
                >
                  <Checkbox>修改此項</Checkbox>
                </Form.Item>
              </Input.Group>
            </Form.Item>
            <Form.Item
              label={I18n.t('服務')}
              name="serviceId"
              rules={[
                {
                  required: serviceRequired
                },
              ]}
            >
              <Select
                showSearch
                placeholder={I18n.t('服務')}
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                {serviceOptions}
              </Select>
            </Form.Item>
            <Form.Item label="服務開始時間">
              <Input.Group compact>
                <Form.Item
                  name={['beginAt', 'value']}
                  rules={[
                    {
                      required: beginAtRequired,
                      message: '請輸入服務開始時間'
                    },
                  ]}
                >
                  <DatePicker
                    placeholder={I18n.t('服務開始時間')}
                  />
                </Form.Item>
                <Form.Item
                  noStyle={false}
                  valuePropName="checked"
                  name={['beginAt', 'checkbox']}
                  style={{ marginLeft: "10px" }}
                >
                  <Checkbox onChange={handleServiceCheckboxChange}>修改此項</Checkbox>
                </Form.Item>
              </Input.Group>
            </Form.Item>
            <Form.Item label="服務結束時間">
              <Input.Group compact>
                <Form.Item
                  name={['endAt', 'value']}
                >
                  <DatePicker
                    placeholder={I18n.t('服務結束時間')}
                  />
                </Form.Item>
                <Form.Item
                  noStyle={false}
                  valuePropName="checked"
                  name={['endAt', 'checkbox']}
                  style={{ marginLeft: "10px" }}
                >
                  <Checkbox onChange={handleServiceCheckboxChange}>修改此項</Checkbox>
                </Form.Item>
              </Input.Group>
            </Form.Item>
            <Form.Item label="成員服務">
              <Input.Group compact>
                <Form.Item
                  name={['memberServiceOption', 'value']}
                  validateStatus="error"
                  help="是否在子服務中啟用該家庭的所有成員，會影響某些子服務的配額，請謹慎開啟。如之前曾加入過此服務，可選擇 ‘保持不變’，使用舊設置。要單獨設置成員子服務，可前往 家庭列表->家庭成員->成員服務列表設置"
                >
                  <Select placeholder={I18n.t('成員服務')}>
                    <Option value="keep">
                      {I18n.t('保持不變')}
                    </Option>
                    <Option value="true">
                      {I18n.t('開啟')}
                    </Option>
                    <Option value="false">
                      {I18n.t('關閉')}
                    </Option>
                  </Select>
                </Form.Item>
                <Form.Item
                  noStyle={false}
                  valuePropName="checked"
                  name={['memberServiceOption', 'checkbox']}
                  style={{ marginLeft: "10px" }}
                >
                  <Checkbox onChange={handleServiceCheckboxChange}>修改此項</Checkbox>
                </Form.Item>
              </Input.Group>
            </Form.Item>
            <Form.Item {...formTailLayout}>
              <Button type="primary" htmlType="submit" block>
                {I18n.t('提交')}
              </Button>
            </Form.Item>
          </Form>
        </Spin>
      ) : <SpinFull />}
    </Modal>
  )
};